import Select from 'react-select'
import React, {FC, useEffect, useMemo, useState} from 'react'
import moment from 'moment-timezone'
import DatePicker from 'react-datepicker'
import ReactPaginate from 'react-paginate'
import InsertNewData from '../../../Components/InsertNewData'
import QuickMessageDrawerInner from '../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import {Button, Modal, Spinner} from 'react-bootstrap'
import {MessageType} from './Types'
import {useMessageReport} from './hooks/useMessageReport'
import {useMessageReport as useMessageReportv3} from './hooks/useMessageReportv3'

import {
  CampType,
  MessageReportParams,
  MessageReportResponse,
} from '../../../../services/cellcast.v2.types'
import {useLoadedData} from '../../../hooks/useGetLoadedData'
import {useLazyQuickMessageReportQuery} from '../../../../services/cellcast.v2'
import {MessageDeliveryOptions, visualizeHiddenCharacters} from './Common'
import VCardPreview from '../../../Components/VCardPreview'
import {useSelector} from 'react-redux'
import {getIsDefaultRegion} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import { useLazyQuickMessageReportsQuery } from '../../../../services/cellcast.v3'

const QuickMessagesPage: FC = () => {
  const {
    params: smsParams,
    setParams: setSmsParams,
    fetchData: smsData,
    setTriggerFetch: setSmsTriggerFetch,
  } = useMessageReport(CampType.sms, useLazyQuickMessageReportQuery)

  const {
    params: mmsParams,
    setParams: setMmsParams,
    fetchData: mmsData,
    setTriggerFetch: setMmsTriggerFetch,
  } = useMessageReport(CampType.mms, useLazyQuickMessageReportQuery)

  const {
    params: smsUsParams,
    setParams: setSmsUsParams,
    fetchData: smsUsData,
    setTriggerFetch: setSmsUsTriggerFetch,
  } = useMessageReportv3(CampType.sms, useLazyQuickMessageReportsQuery)

  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const [quickMessagePopup, setQuickMessagePopup] = useState(false)

  return (
    <div className='row'>
      {AuthenticateUser('send-quick-sms') && quickMessagePopup && (
        <QuickMessageDrawerInner
          handleClose={() => setQuickMessagePopup(false)}
          show={quickMessagePopup}
        />
      )}

      {isDefaultRegion ? (
        <>
          <QuickMessages
            params={smsParams}
            setParams={setSmsParams}
            isFetching={smsData.isFetching}
            isLoading={smsData.isLoading}
            data={smsData.data}
            triggerFetch={setSmsTriggerFetch}
            openQuickMessage={setQuickMessagePopup}
          />

          <QuickMessages
            params={mmsParams}
            setParams={setMmsParams}
            isFetching={mmsData.isFetching}
            isLoading={mmsData.isLoading}
            data={mmsData.data}
            triggerFetch={setMmsTriggerFetch}
            openQuickMessage={setQuickMessagePopup}
          />
        </>
      ) : (
        <QuickMessagesV3
          params={smsUsParams}
          setParams={setSmsUsParams}
          isFetching={smsUsData.isFetching}
          isLoading={smsUsData.isLoading}
          data={smsUsData.data}
          triggerFetch={setSmsUsTriggerFetch}
          openQuickMessage={setQuickMessagePopup}
        />
      )}
    </div>
  )
}

type ImageModalProps = {
  show: boolean
  url: string
  isVCard?: boolean
  onClose: () => void
}
const ImageModal: FC<ImageModalProps> = (props) => {
  const {isVCard, show, url, onClose} = props

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Body>
        <div className='card-header'>
          <div className='card-title'>
            <h2 className='text-center'>{isVCard ? 'VCard' : 'Image'} Preview</h2>
          </div>
          <div className='card-toolbar align-items-center'></div>
        </div>
        <div className='card-body p-0'>
          {isVCard ? (
            <VCardPreview vcfUrl={url} />
          ) : (
            <img src={url} alt='Preview' style={{width: '100%', height: 'auto'}} />
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

type QuickMessageProps = {
  isFetching: boolean
  isLoading: boolean
  data: MessageReportResponse | undefined
  params: MessageReportParams
  setParams: (params: MessageReportParams) => void
  triggerFetch: (isFetch: boolean) => void
  openQuickMessage: (isOpen: boolean) => void
}
const QuickMessages: FC<QuickMessageProps> = (props) => {
  const {calculate, loadedData, setLoadedData} = useLoadedData()
  const {isFetching, isLoading, data, params, setParams, triggerFetch, openQuickMessage} = props

  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([sevenDaysAgo, new Date()])
  const [startDate, endDate] = dateRange

  const [showImageUrl, setImageUrl] = useState('')
  const [isVcard, setIsVCard] = useState(false)
  const [showImageModal, setShowImageModal] = useState(false)

  const setDateParams = (dateRangeParams: [Date | null, Date | null]) => {
    let [startDate, endDate] = dateRangeParams

    if (endDate === null) {
      endDate = new Date()
    }

    setParams({
      ...params,
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
    })

    triggerFetch(true)
    setDateRange(dateRangeParams)
  }

  useEffect(() => {
    if (data) {
      const loadedData = calculate(
        data && data.data.current ? data.data.current : 1,
        params.limit,
        data && data.data.total ? data.data.total : 0
      )
      setLoadedData(loadedData)
    }
  }, [isLoading, isFetching])

  const ImagePreviewModal = useMemo(
    () => (
      <ImageModal
        show={showImageModal}
        isVCard={isVcard}
        url={showImageUrl}
        onClose={() => {
          setShowImageModal(false)
          setImageUrl('')
          setIsVCard(false)
        }}
      />
    ),
    [showImageModal, showImageUrl]
  )
  return (
    <div className='mt-8'>
      {ImagePreviewModal}
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-10'>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>
                All Quick {params.campType?.toUpperCase()} Messages
              </span>
              <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
            </h3>
            <div className='d-flex justify-content-end'>
              <div className='col-md-3'>
                <div className='d-flex'>
                  <DatePicker
                    selectsRange={true}
                    dateFormat='MMM d, yyyy'
                    className=' border-0 form-control form-control-lg form-control-solid'
                    placeholderText='Pick data & time'
                    onChange={(update) => {
                      setDateParams(update)
                    }}
                    startDate={startDate}
                    endDate={endDate}
                    disabled={isLoading}
                  />
                  <span
                    className='input-group-text'
                    style={{backgroundColor: '#f5f8fa', borderRadius: 0, borderColor: '#f5f8fa'}}
                  >
                    <i className='bi bi-calendar'></i>
                  </span>
                </div>
              </div>
              <div className='ms-2 col-xs-4 col-md-3 '>
                <Select
                  value={
                    MessageDeliveryOptions.find((e) => e.value === params.status) ||
                    MessageDeliveryOptions[0]
                  }
                  options={MessageDeliveryOptions}
                  onChange={(e) => {
                    setParams({...params, status: e?.value})
                    triggerFetch(true)
                  }}
                  isDisabled={isLoading}
                />
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data.items && data.data.items.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th className='p-0 min-w-100px'>Type</th>
                        <th className='p-0'>Date</th>
                        <th className='p-0 min-w-30px ps-3'>From / CustomerID</th>
                        <th className='p-0 min-w-30px ps-3'>Number</th>
                        <th className='p-0 min-w-60px ps-3'>Message</th>
                        <th className='p-0 min-w-60px ps-3'>Reply</th>
                        <th className='p-0 min-w-30px ps-3'>Message Part</th>
                        <th className='p-0 min-w-30px ps-3'>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={7} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.items?.map((key, i: number) => (
                            <React.Fragment key={i}>
                              <tr className='border-dashed border-2 border-bottom'>
                                <td className='top-align'>
                                  <div className='symbol symbol-50px me-2'>
                                    <span className='symbol-label badge green_text_badge fs-7 badge-square p-4 w-50px h-50px'>
                                      {params.campType?.toUpperCase()}
                                    </span>
                                  </div>
                                </td>
                                <td className='top-align'>
                                  <span className='text-dark-400  p-0'>
                                    {moment(key?.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                                  </span>
                                </td>
                                <td className='top-align'>{key?.sender || '-'}</td>
                                <td className='top-align'>{key?.receiver || '-'}</td>
                                <td className='top-align'>
                                  <div className='message-display'>{key?.message || '-'}</div>
                                  {key.media && Array.isArray(key.media) && key.media.length > 0 && (
                                    <>
                                      <br />
                                      <Button
                                        size='sm'
                                        className='btm btn-sm mt-5'
                                        onClick={() => {
                                          setImageUrl(key.media ? key.media[0].url : '')
                                          setShowImageModal(true)
                                          if (
                                            key.media &&
                                            key?.media[0]?.filetype === 'text/vcard'
                                          ) {
                                            setIsVCard(true)
                                          }
                                        }}
                                      >
                                        {key.media && key?.media[0]?.filetype === 'text/vcard'
                                          ? 'Show VCard'
                                          : 'Show Image'}
                                      </Button>
                                    </>
                                  )}
                                </td>
                                <td className='top-align'>
                                  <div className='message-display'>
                                    {key.customerResponse || '-'}
                                  </div>
                                  {key.customerResponseMedia &&
                                    Array.isArray(key.customerResponseMedia) &&
                                    key.customerResponseMedia.length > 0 && (
                                      <>
                                        <br />
                                        <Button
                                          size='sm'
                                          className='btm btn-sm mt-5'
                                          onClick={() => {
                                            setImageUrl(
                                              key.customerResponseMedia
                                                ? key.customerResponseMedia[0].url
                                                : ''
                                            )
                                            setShowImageModal(true)
                                          }}
                                        >
                                          Show Image
                                        </Button>
                                      </>
                                    )}
                                </td>
                                <td className='top-align text-center'>
                                  {key?.smsDetail?.smscount || key?.gateway_count || '--'}
                                </td>
                                <td className='top-align'>
                                  <span
                                    className={`badge badge-light-${
                                      ['received', 'delivered'].includes(key?.status)
                                        ? 'success'
                                        : ['failed', 'expired', 'rejected'].includes(key?.status)
                                        ? 'danger'
                                        : 'warning'
                                    } fw-bold`}
                                  >
                                    {key.status ? key.status.toUpperCase() : 'Pending'}
                                  </span>
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className='abcd'>
                  <select
                    onChange={(e: any) => {
                      setParams({...params, limit: e.target.value})
                      triggerFetch(true)
                    }}
                    value={params.limit || 10}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  {isFetching
                    ? '. . . . .'
                    : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${
                        data.data.total ? data.data.total : 0
                      } Messages`}
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={data?.data?.totalPages}
                    onPageChange={(e: any) => {
                      setParams({...params, page: e.selected + 1})
                      triggerFetch(true)
                    }}
                    containerClassName={'pagination'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            ) : (
              <InsertNewData
                message={{
                  title: 'No recent quick messages (yet!)',
                  subtitle: `It looks like you haven't sent any messages yet, why don't you give it a try?`,
                }}
                buttonName={{
                  name: 'Send Quick message',
                  link: '',
                  popup: true,
                  buttonFun: () => openQuickMessage(true),
                }}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}


type QuickMessageV3Props = {
  isFetching: boolean
  isLoading: boolean
  data: any
  params: MessageReportParams
  setParams: (params: MessageReportParams) => void
  triggerFetch: (isFetch: boolean) => void
  openQuickMessage: (isOpen: boolean) => void
}
const QuickMessagesV3: FC<QuickMessageV3Props> = (props) => {
  const {calculate, loadedData, setLoadedData} = useLoadedData()
  const {isFetching, isLoading, data, params, setParams, triggerFetch, openQuickMessage} = props

  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([sevenDaysAgo, new Date()])
  const [startDate, endDate] = dateRange

  const [showImageUrl, setImageUrl] = useState('')
  const [isVcard, setIsVCard] = useState(false)
  const [showImageModal, setShowImageModal] = useState(false)

  const setDateParams = (dateRangeParams: [Date | null, Date | null]) => {
    let [startDate, endDate] = dateRangeParams

    if (endDate === null) {
      endDate = new Date()
    }

    setParams({
      ...params,
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
    })

    triggerFetch(true)
    setDateRange(dateRangeParams)
  }

  useEffect(() => {
    if (data) {
      const loadedData = calculate(
        data && data.data.current ? data.data.current : 1,
        params.limit,
        data && data.data.total ? data.data.total : 0
      )
      setLoadedData(loadedData)
    }
  }, [isLoading, isFetching])

  const ImagePreviewModal = useMemo(
    () => (
      <ImageModal
        show={showImageModal}
        isVCard={isVcard}
        url={showImageUrl}
        onClose={() => {
          setShowImageModal(false)
          setImageUrl('')
          setIsVCard(false)
        }}
      />
    ),
    [showImageModal, showImageUrl]
  )

  return (
    <div className='mt-8'>
      {ImagePreviewModal}
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-10'>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>
                All Quick {params.campType?.toUpperCase()} Messages
              </span>
              <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
            </h3>
            <div className='d-flex justify-content-end'>
              <div className='col-md-3'>
                <div className='d-flex'>
                  <DatePicker
                    selectsRange={true}
                    dateFormat='MMM d, yyyy'
                    className=' border-0 form-control form-control-lg form-control-solid'
                    placeholderText='Pick data & time'
                    onChange={(update) => {
                      setDateParams(update)
                    }}
                    startDate={startDate}
                    endDate={endDate}
                    disabled={isLoading}
                  />
                  <span
                    className='input-group-text'
                    style={{backgroundColor: '#f5f8fa', borderRadius: 0, borderColor: '#f5f8fa'}}
                  >
                    <i className='bi bi-calendar'></i>
                  </span>
                </div>
              </div>
              <div className='ms-2 col-xs-4 col-md-3 '>
                <Select
                  value={
                    MessageDeliveryOptions.find((e) => e.value === params.status) ||
                    MessageDeliveryOptions[0]
                  }
                  options={MessageDeliveryOptions}
                  onChange={(e) => {
                    setParams({...params, status: e?.value})
                    triggerFetch(true)
                  }}
                  isDisabled={isLoading}
                />
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data && data.data?.items?.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th className='p-0 min-w-100px'>Type</th>
                        <th className='p-0'>Date</th>
                        <th className='p-0 min-w-30px ps-3'>From / CustomerID</th>
                        <th className='p-0 min-w-30px ps-3'>Number</th>
                        <th className='p-0 min-w-60px ps-3'>Message</th>
                        <th className='p-0 min-w-60px ps-3'>Reply</th>
                        <th className='p-0 min-w-30px ps-3'>Message Part</th>
                        <th className='p-0 min-w-30px ps-3'>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={7} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.items?.map((key: any, i: number) => (
                            <React.Fragment key={i}>
                              <tr className='border-dashed border-2 border-bottom'>
                                <td className='top-align'>
                                  <div className='symbol symbol-50px me-2'>
                                    <span className='symbol-label badge green_text_badge fs-7 badge-square p-4 w-50px h-50px'>
                                      {params.campType?.toUpperCase()}
                                    </span>
                                  </div>
                                </td>
                                <td className='top-align'>
                                  <span className='text-dark-400  p-0'>
                                    {moment(key?.created_at).format('DD-MM-YYYY HH:mm:ss')}
                                  </span>
                                </td>
                                <td className='top-align'>{key?.sender || '-'}</td>
                                <td className='top-align'>{key?.receiver || '-'}</td>
                                <td className='top-align'>
                                  <div className='message-display'>{key?.message || '-'}</div>
                                  {key.media && Array.isArray(key.media) && key.media.length > 0 && (
                                    <>
                                      <br />
                                      <Button
                                        size='sm'
                                        className='btm btn-sm mt-5'
                                        onClick={() => {
                                          setImageUrl(key.media ? key.media[0].url : '')
                                          setShowImageModal(true)
                                          if (
                                            key.media &&
                                            key?.media[0]?.filetype === 'text/vcard'
                                          ) {
                                            setIsVCard(true)
                                          }
                                        }}
                                      >
                                        {key.media && key?.media[0]?.filetype === 'text/vcard'
                                          ? 'Show VCard'
                                          : 'Show Image'}
                                      </Button>
                                    </>
                                  )}
                                </td>
                                <td className='top-align'>
                                  <div className='message-display'>
                                    {key.response_message?.message || '-'}
                                  </div>
                                  {key.customerResponseMedia &&
                                    Array.isArray(key.customerResponseMedia) &&
                                    key.customerResponseMedia.length > 0 && (
                                      <>
                                        <br />
                                        <Button
                                          size='sm'
                                          className='btm btn-sm mt-5'
                                          onClick={() => {
                                            setImageUrl(
                                              key.customerResponseMedia
                                                ? key.customerResponseMedia[0].url
                                                : ''
                                            )
                                            setShowImageModal(true)
                                          }}
                                        >
                                          Show Image
                                        </Button>
                                      </>
                                    )}
                                </td>
                                <td className='top-align text-center'>
                                  {key?.message_part || '--'}
                                </td>
                                <td className='top-align'>
                                  <span
                                    className={`badge badge-light-${
                                      ['received', 'delivered'].includes(key?.status)
                                        ? 'success'
                                        : ['failed', 'expired', 'rejected'].includes(key?.status)
                                        ? 'danger'
                                        : 'warning'
                                    } fw-bold`}
                                  >
                                    {key.status ? key.status.toUpperCase() : 'Pending'}
                                  </span>
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className='abcd'>
                  <select
                    onChange={(e: any) => {
                      setParams({...params, limit: +e.target.value})
                      triggerFetch(true)
                    }}
                    value={params.limit || 10}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  {isFetching
                    ? '. . . . .'
                    : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${
                        data.data.total ? data.data.total : 0
                      } Messages`}
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={data?.data?.totalPages}
                    onPageChange={(e: any) => {
                      setParams({...params, page: e.selected + 1})
                      triggerFetch(true)
                    }}
                    containerClassName={'pagination'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            ) : (
              <InsertNewData
                message={{
                  title: 'No recent quick messages (yet!)',
                  subtitle: `It looks like you haven't sent any messages yet, why don't you give it a try?`,
                }}
                buttonName={{
                  name: 'Send Quick message',
                  link: '',
                  popup: true,
                  buttonFun: () => openQuickMessage(true),
                }}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default QuickMessagesPage
